import { Button, Form, InputNumber } from "antd";
import styled from "styled-components";
import { MyButton } from "../../components/Button/style";
import { Swiper } from "swiper/react";
import "swiper/css";
export const StakeNotify = styled.div`
  background: #eaf2ff;
  border-radius: 10px;
  padding: 12.5px 23px;
  display: flex;
  align-items: flex-start;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  background: #F5AA194D;
  color: #000000;
  & svg {
    margin-top: 3px;
    margin-right: 15px;
    width: 20px;
    height: 20px;
    flex: none;
  }

  & > div {
    flex: 1;
  }

  & ul {
    margin-bottom: 0;
  }

  @media screen and (max-width: 1024px) {
    border-radius: 20px;
    padding: 24px 44px 24px 17px;
    margin-top: 50px;
  }
`;

export const TitleLablelForm = styled.span`
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;

  color: #000000;
  @media screen and (max-width: 640px) {
    font-size: 20px;
  }
`;

export const AddonAfter = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;

  @media screen and (max-width: 640px) {
    font-size: 14px;
  }
`;

export const AvailableBalanceTitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.8);
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 65px;
  background: #ffffff;
  border-radius: 24.3px;
  padding: 10px 20px 10px 16px;
  /* width: 109px; */
  height: 50px;
  cursor: pointer;

  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  &.checked {
    color: #ffffff;
    background-color: #000000;
  }
  &:hover {
    color: #ffffff;
    background-color: #000000;
  }
  @media (max-width: 640px) {
    color: #000000cc;
    font-size: 14px;
    line-height: 17px;
  }
`;

export const OrderSummary = styled.div`
  background: #ffffff;
  border-radius: 10px;

  padding: 24px 33px 16px 40px;
  @media (max-width: 640px) {
    padding: 28px 22px 29px 26px;
  }
`;

export const OrderSummaryTitle = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;

  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

export const OrderSummaryLabel = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  color: #818181;
`;

export const OrderSummaryValue = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  text-align: right;
  color: #000000;
`;

export const AgreeTitle = styled.span`
  font-weight: ${(props) => props.fontweight || 400};
  font-size: 16px;
  line-height: 24px;
  color: #4f4f4f;
  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const ButtonMax = styled(Button)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #F12E11;
  border: none;
  outline: none;
  background: transparent;
  box-shadow: none;
  &:hover,
  &:focus {
    outline: none;
    background: transparent;
  }
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

export const ButtonConfirm = styled(MyButton)`
  height: 52px;
  min-width: 160px;
  box-shadow: none;
  background: #000000 !important;
  border-radius: 15px !important;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff !important;
  border: none;

  &.ant-btn[disabled] {
    opacity: 0.5 !important;
    border: none;
    color: #bfbfbf !important;
  }

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;

export const LabelFormPopupDetail = styled.span`
  display: flex;
  align-items: center;
  min-width: 213px;
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  color: #818181;

  @media (max-width: 1024px) {
    min-width: 130px;
    font-size: 14px;
  }
  @media (max-width: 400px) {
    min-width: 100px;
  }
`;

export const ValueFormPopupDetail = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  text-align: right;
  color: #000000;
  width: 100%;
  color: #000000;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const OptionDurationWraper = styled.div`
  margin-top: 18px;
  position: relative;
  &.showOver {
    &::before {
      content: "";
      position: absolute;
      pointer-events: none;
      z-index: 10;
      width: 81px;
      height: 77px;
      right: -6px;
      bottom: -15px;
      background: linear-gradient(
        270deg,
        #f5f5f5 20.8%,
        rgba(245, 245, 245, 0) 113.61%
      );
    }
  }
`;

export const SwiperWraper = styled(Swiper)`
  position: relative;
  &::after {
    content: "";
  }
`;
